import React, { useEffect, useState } from 'react';
import axios from 'axios';
import bgImg1 from '../assets/bg-img-1.jpg';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });
  const [statusMessage, setStatusMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        'https://thecfagroup.org/v1/api/admin/send_contact_us',
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      setStatusMessage('Your message has been sent successfully!');
      setFormData({ name: '', phone: '', email: '', message: '' });
    } catch (error) {
      setStatusMessage('Failed to send message. Please try again.');
      console.error('Error sending contact message:', error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div
        className="relative h-[40vh] sm:h-[50vh] bg-cover bg-center z-1"
        style={{ backgroundImage: `url(${bgImg1})` }}
      >
        <div className="absolute inset-0 bg-[#03000c] opacity-75"></div>
        <div className="absolute z-1 flex flex-col items-start justify-center min-h-full w-[90%] sm:w-[70%] px-4 mt-6 sm:px-10 md:px-16">
          <div className="text-white text-left px-4 py-6 w-full max-w-3xl mx-auto">
            <h1 className="text-[30px] sm:text-[50px] md:text-[70px] font-extrabold leading-tight mb-4 animate-fade-in-up">
              Contact us
            </h1>
          </div>
        </div>
      </div>
      
      <div className="flex justify-center flex-col gap-12 items-center pt-10 pb-10 sm:pt-16 sm:pb-16 px-4 bg-gray-100">
        <div className="w-full max-w-6xl p-6 sm:p-8 bg-white shadow-xl rounded-lg">
          <div className="w-full max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 sm:mb-8 text-center">Write your query</h1>
            {statusMessage && <p className="text-center mb-4 text-lg text-green-600">{statusMessage}</p>}
            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="border p-2 sm:p-3 w-full"
                  required
                />
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="border p-2 sm:p-3 w-full"
                  required
                />
              </div>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="border p-2 sm:p-3 w-full"
                required
              />
              <textarea
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
                className="border p-2 sm:p-3 w-full h-32 sm:h-40"
                required
              />
              <button
                type="submit"
                className="bg-[#25a182] text-white py-2 sm:py-3 px-4 sm:px-6 rounded w-full hover:text-[#25a182] hover:bg-white hover:border hover:border-[#25a182] transition-transform duration-300 transform hover:translate-y-[-4px]"
              >
                Send
              </button>
            </form>
          </div>
        </div>
        {/* <iframe
          className="w-full mt-4 max-w-6xl shadow-xl rounded-lg"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14441.076181635268!2d55.267726695228994!3d25.19414780995434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f682f700cf983%3A0xb5cc58b076c0b904!2sDowntown%20Dubai%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1727436961570!5m2!1sen!2sin"
          width="600"
          height="450"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe> */}
      </div>
    </div>
  );
};

export default Contact;
